module.exports = __webpack_public_path__ + "img/type-italic.1df2897c.svg";